import moment from 'moment'

import { NavigationParams } from 'modules/attendance/lib/types'

class EmployeeUtils {
  static isActiveInPeriod(
    terminatedOn: string | null | undefined,
    params: NavigationParams
  ): boolean {
    if (!terminatedOn) return true

    const startDate = moment([
      parseInt(params.year),
      parseInt(params.month) - 1,
      params.day ? parseInt(params.day) : 1,
    ])

    const terminationDate = moment(terminatedOn)

    return terminationDate.isSameOrAfter(startDate)
  }
}

export default EmployeeUtils
